import { STEPS, CHANGE_STEP_FORM, RESET, CHANGE_TYPE_CAR, CHANGE_REDIRECT } from '../actions/PasosFormulario';

const initialValues = {
    stepForm: STEPS.RESERVACION,
    stepActive: {
        stepVehiculos: false,
        stepCoberturas: false,
        stepDatosCliente: false,
        stepConfirmacion: false,
        stepFinal: false
    },
    typeCar: 'SEDAN',
    stepWay: 'WAY_RESERVAR',
    stepPrev: STEPS.RESERVACION,
    redirect: false
}


const activeStep = (state, action) => {

    const { stepActive } = state;
    console.log("########################### action.step.stepForm ########################### ",action.step.stepForm);
    switch (action.step.stepForm) {
        case STEPS.VEHICULO:
            return {
                ...stepActive,
                stepVehiculos: true
            }
        case STEPS.COBERTURAS:
            return {
                ...stepActive,
                stepCoberturas: true,
                stepWay: 'WAY_RESERVAR'
            }
        case STEPS.COTIZAR:
            console.log("STEPS: COTIZAR");
            return {
                ...stepActive,
                stepDatosCliente: true,
                stepWay: 'WAY_COTIZAR'
            }
        case STEPS.DATOS_CLIENTE:
            return {
                ...stepActive,
                stepDatosCliente: true
            }
        case STEPS.CONFIRMACION:
            return {
                ...stepActive,
                stepConfirmacion: true
            }
        case STEPS.FINAL:
            return {
                ...stepActive,
                stepFinal: true
            }
        default:
            return stepActive;
    }
}


const pasosReservacionReducer = (state = initialValues, action) => {

   // console.log("pasosReservacionReducer " , action.type);
   // console.log("stepForm " , action.step);
    //console.log("state " , state);
    switch (action.type) {
        case CHANGE_STEP_FORM:
            
            //console.log(action);
            //console.log(" prev step : ",state.stepFor);
            console.log(" ************************ prev STATE ************************  : ", state);
            let steWayVar = state.stepWay;
            console.log(" ########### STEPWAY PREV ########### : ", steWayVar);
            if(state.stepForm === STEPS.DATOS_CLIENTE  && action.step.stepForm === STEPS.COBERTURAS ){
                steWayVar = 'WAY_RESERVAR';
            }

            if(action.step.stepForm === STEPS.COTIZAR){
                steWayVar = 'WAY_COTIZAR';
            }
            console.log(" ########### STEPWAY NEXT ########### : ", steWayVar);
            const stateNew = {
                ...state,
                stepPrev: state.stepForm,
                stepForm: action.step.stepForm,
                redirect: action.redirect,
                stepActive: activeStep(state, action),
                stepWay: steWayVar
                //stepWay: action.step.stepForm === STEPS.COTIZAR ? 'WAY_COTIZAR' : 'WAY_RESERVAR'
            };
            //console.log(stateNew);
            return stateNew;
        case CHANGE_TYPE_CAR:
            return {
                ...state,
                typeCar: action.typeCar,
                redirect: action.redirect,
            }
        case CHANGE_REDIRECT:
            return {
                ...state,
                redirect: action.redirect
            }
        case RESET:
            return initialValues;
        default:
            return state;
    }

}

export default pasosReservacionReducer;